import { InputContainer, Label } from '../../global/styles';
import Switch from '../Switch';

interface Props {
	onChange: (v: boolean) => void;
	value: boolean;
}
export default function EnabledToggle({ onChange, value }: Props) {
	return (
		<InputContainer>
			<Label>Enable this section</Label>
			<Switch value={value} onChange={() => onChange(!value)} />
		</InputContainer>
	);
}
